import * as React from 'react';

import {EarnedBonusReportContent} from '/component/partial/reportCard/EarnedBonusReportContent';
import {useTranslation} from '/provider/TranslationProvider';
interface Props {
  recordData: Record<string, any>;
}

export const EarnedCabReportContent: React.FC<Props> = ({recordData = {}}) => {
  const {earnedCabOn, newOrderingEntitiesCount, cabFqv} = recordData;
  const record = {earnedOn: earnedCabOn, newOrderingEntitiesCount, fqv: cabFqv};
  const {tt} = useTranslation('reportCardContent.earnedCab');
  return (
    <EarnedBonusReportContent
      recordData={record}
      bonusTitle={tt('title', 'Earned Client Acquisition Bonus')}
      fqvName={tt('fqvDuringCabPeriod', 'FQV during CAB Period')}
    />
  );
};
